module.exports = __webpack_public_path__ + "static/media/majorC2.d72b48c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorC2.wav
// module id = vDQF
// module chunks = 0